import FinancialStatementsFooter from './FinancialStatementsFooter';

export default FinancialStatementsFooter;
